export { default } from './Polls';
